module.exports = __webpack_public_path__ + "img/hr.f17ac845.png";